<template>
      <appbarView />
  <v-app>
    <v-snackbar
      v-model="preventaSnackbar.show"
      location="top"
      color="orange"
      class="mt-20 text-white"
      timeout="4000"
    >
      {{ preventaSnackbar.message }}
    </v-snackbar>



    <v-main>
      
      <v-container fluid>
        <!-- ✅ Contenedor agregado -->

        <!-- ✅ Sección: Marcas -->
        <div class="text-center my-4">
          <span class="font-bold text-blue-darken-5 text-lg drop-shadow-md">
            Explora nuestras marcas
          </span>
        </div>

        <div class="marcas py-2">
          <div
            class="flex gap-4 overflow-x-auto px-2"
            style="scroll-behavior: smooth; white-space: nowrap"
          >
            <v-col
              v-for="(item, index) in transitions"
              :key="index"
              cols="auto"
              class="pa-0 flex flex-col items-center inline-block"
            >
              <v-card
                :class="item.color"
                hover
                :width="$vuetify.display.smAndDown ? '75px' : '80px'"
                :height="$vuetify.display.smAndDown ? '75px' : '80px'"
                elevation="4"
                style="
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
                @pointerdown="startPointer($event, item.route)"
                @pointerup="endPointer($event)"
              >
                <v-img
                  lazyloading
                  :src="item.image"
                  :height="$vuetify.display.smAndDown ? '65px' : '70px'"
                  :width="$vuetify.display.smAndDown ? '65px' : '70px'"
                  class="cursor-pointer"
                  style="object-fit: cover; border-radius: 50%"
                />
              </v-card>

              <v-card-title
                class="product-title text-center font-medium"
                :style="{
                  fontSize: $vuetify.display.smAndDown ? '11px' : '14px',
                  paddingTop: '8px',
                  color: '#1E3A8A',
                }"
              >
                {{ item.name }}
              </v-card-title>
            </v-col>
          </div>
        </div>

        <!-- Categorías -->
        <div class="text-center my-4">
          <span class="font-bold text-blue-darken-5 text-lg drop-shadow-md">
            Explora nuestras Categorías
          </span>
        </div>

        <div class="marcas py-2">
          <div
            class="flex gap-4 overflow-x-auto px-2"
            style="scroll-behavior: smooth; white-space: nowrap"
          >
            <v-col
              v-for="(item, index) in products"
              :key="index"
              cols="auto"
              class="pa-0 flex flex-col items-center inline-block"
            >
              <v-card hover @click="navigateTo(item.route)">
                <v-img
                  lazyloading
                  :src="item.image"
                  :height="$vuetify.display.smAndDown ? '120px' : '120px'"
                  :width="$vuetify.display.smAndDown ? '120px' : '120px'"
                  class="cursor-pointer"
                  style="object-fit: cover; border-radius: 8px"
                />
              </v-card>

              <v-card-title
                class="product-title text-center font-medium"
                :style="{
                  fontSize: $vuetify.display.smAndDown ? '11px' : '14px',
                  paddingTop: '8px',
                  color: 'blue-darken-4',
                }"
              >
                {{ item.category }}
              </v-card-title>
            </v-col>
          </div>
        </div>

        <!-- Botón del carrito flotante -->
      <!-- Botón flotante tipo Didi/Rappi -->
      <v-btn icon class="floating-cart-btn" color="blue-darken-4" @click="openCart" elevation="10">
        <v-icon color="white" size="30">mdi-cart-outline</v-icon>
        <span v-if="totalCajas > 0" class="cart-badge">{{ totalCajas }}</span>
      </v-btn>


        <div class="text-center my-4">
          <span class="font-bold text-blue-darken-5 text-lg drop-shadow-md">
            Explora nuestros productos
          </span>
        </div>

        <div
          ref="ofertadosContainer"
          style="height: 80vh; overflow-y: auto; padding: 8px"
        >
          <!-- Buscador -->
          <div class="mb-6">
            <div class="relative w-full max-w-md mx-auto">
              <input
                v-model="searchQuery"
                type="text"
                placeholder="Buscar productos"
                class="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-orange-400"
              />
              <br /><br />
              <p
                class="text-center text-xs md:text-sm text-gray-600 uppercase tracking-wider"
              >
                Evita el exceso
              </p>
              <br />
              <span class="absolute left-3 top-2.5 text-gray-400">
                <i class="mdi mdi-magnify"></i>
              </span>
            </div>
          </div>

          <!-- Productos -->
                <v-row dense>
          <v-col
            v-for="product in filteredOfertados"
            :key="product.id"
            cols="6"
            sm="6"
            md="4"
            lg="3"
            class="d-flex justify-center"
          >
            <v-card class="pa-4" variant="transparent" style="width: 240px">
              <v-row>
                <div class="d-flex align-center" style="position: relative">
                  <!-- Bloque de botones dinámicos -->
                  <div
                    v-if="getProductQuantity(product) > 0"
                    class="d-flex align-center mt-2"
                  >
                    <!-- Botón disminuir / eliminar -->
                    <v-btn
                      icon
                      @click="
                        getProductQuantity(product) === 1
                          ? removeFromCart(product)
                          : decreaseQuantity(product)
                      "
                      variant="transparent"
                      density="compact"
                      :color="
                        getProductQuantity(product) === 1 ? 'red' : 'orange-darken-1'
                      "
                    >
                      <v-icon>
                        {{
                          getProductQuantity(product) === 1
                            ? "mdi-delete"
                            : "mdi-minus-circle"
                        }}
                      </v-icon>
                    </v-btn>

                    <!-- Cantidad actual -->
                    <span
                      class="px-2 text-caption font-weight-bold"
                      style="font-size: 1.2em"
                    >
                      {{ getProductQuantity(product) }}
                    </span>

                    <!-- Botón aumentar -->
                    <v-btn
                      icon
                      size="42"
                      @click="increaseQuantity(product)"
                      density="compact"
                      variant="transparent"
                      color="blue-darken-4"
                      :disabled="
                        product.id_promocion
                          ? getProductQuantity(product) >= 5
                          : getProductQuantity(product) >= product.yfr_disponible
                      "
                    >
                      <v-icon>mdi-plus-circle</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-row>

              <v-row class="d-flex justify-center" style="position: relative">
                <v-col cols="9" style="position: relative">
                  <!-- Imagen -->
                  <v-img
                    lazyloading
                    :src="product.foto || 'default-image-url'"
                    height="100px"
                    class="rounded"
                    size="40"
                  />

                  <!-- Icono de agregar -->
                  <v-icon
                    color="blue-darken-4"
                    size="42"
                    v-ripple
                    class="add-icon"
                    style="
                      position: absolute;
                      top: 5px;
                      right: 5px;
                      background: white;
                      border-radius: 50%;
                      padding: 2px;
                      cursor: pointer;
                    "
                    :disabled="
                      product.id_promocion
                        ? getProductQuantity(product) >= 1 // 🔒 Si tiene promo, solo 1
                        : getProductQuantity(product) >= product.yfr_disponible
                    "
                    @click="
                      ((product.id_promocion && getProductQuantity(product) < 1) ||
                        (!product.id_promocion &&
                          getProductQuantity(product) < product.yfr_disponible)) &&
                        addToCart(product)
                    "
                    :class="{
                      'v-icon--disabled': product.id_promocion
                        ? getProductQuantity(product) >= 1
                        : getProductQuantity(product) >= product.yfr_disponible,
                    }"
                    :style="
                      getProductQuantity(product) > 0
                        ? 'pointer-events: none; opacity: 0;'
                        : ''
                    "
                  >
                    mdi-plus-circle
                  </v-icon>
                </v-col>
              </v-row>

              <!-- Precio / Promo -->
              <div
                class="w-full text-center mt-4 p-3 transition-shadow duration-300 space-y-1"
              >
                <template v-if="product.id_promocion && product.promo_price">
                  <div class="text-gray-500 line-through font-semibold">
                    ${{ product.price }}
                  </div>
                  <div class="text-base sm:text-lg md:text-xl font-semibold text-red">
                    ${{
                      (
                        product.price -
                        (product.price * product.promo_price) / 100
                      ).toFixed(2)
                    }}
                  </div>
                </template>
                <template v-else>
                  <div
                    class="text-base sm:text-lg md:text-xl font-semibold text-blue-700"
                  >
                    ${{ product.price }}
                  </div>
                </template>

                <!-- Nombre -->
                <div class="text-xs sm:text-sm md:text-base font-medium text-gray-700">
                  {{ product.nombre }}
                </div>

                <!-- SKU -->
                <div class="text-xs sm:text-sm font-medium text-gray-400">
                  SKU: {{ product.sku }}
                </div>

                <!-- Distintivo de promoción -->
                <div
                  v-if="product.id_promocion && product.promo_price"
                  class="mt-1 inline-block px-2 py-1 bg-green-500 text-white text-xs font-bold rounded-full"
                >
                  Descuento {{ product.promo_price }}%
                </div>

                <!-- Agotado -->
                <div
                  v-if="product.yfr_disponible <= 0"
                  class="text-sm sm:text-base font-semibold text-red-500"
                >
                  Agotado
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
    

        </div>

        <!-- Dialogo del carrito -->
        <CartDialog v-model="cartDialog" />

        <!-- Navegación inferior -->
      </v-container>
      <!-- ✅ Cierre del contenedor -->


    </v-main>

          <bottom-navigation class="fixed-bottom-nav"/>


  </v-app>
</template>

<script>
import appbarView from "./appbar/appbarView.vue";
import BottomNavigation from "./submenu/BottomNavigation.vue";
import axios from "axios";
import { inject, computed } from "vue";
import CartDialog from "./Administrador/CarritoViewStore.vue";
import Swal from "sweetalert2";
import {useUserStore} from "../stores/userStore";   

export default {
  name: "MarcasXProductoView",
  components: {
    appbarView,
    BottomNavigation,
    CartDialog,
  },
  setup() {
    const cartStore = inject("cartStore");

    if (!cartStore) {
      throw new Error("cartStore is not provided");
    }

    const addToCart = cartStore.addToCart;
    const increaseQuantity = cartStore.increaseQuantity;
    const decreaseQuantity = cartStore.decreaseQuantity;
    const getProductQuantity = cartStore.getProductQuantity;
      const removeFromCart = cartStore.removeFromCart;


    const totalCajas = computed(() =>
      cartStore.state.cart.reduce((total, item) => total + item.quantity, 0)
    );

    return {
      
      addToCart,
      increaseQuantity,
      removeFromCart,
      decreaseQuantity,
      getProductQuantity,
      totalCajas,
    };
  },
  data() {
    return {
      userStore: useUserStore(),
      startX: 0,
      preventaSnackbar: { show: false, message: "" },
      startY: 0,
      drawer: false,
      offset: 0,
      limit: 30,
      searchQuery: "",
      cart: [],
      cartDialog: false,
      sugerencias: [],
      suggestedItems: [],
      expand: false,
      ofertados: [],
      snackbar: {
        show: false,
        message: "",
        color: "green", // 'success', 'error', 'warning', 'info'
      },
      transitions: [
        {
          image:
            "https://www.penafiel.com/wp-content/themes/penafiel/images/penafiel-logo.png",
          color: "bg-white",
          route: "/101List",
        },
        {
          image:
            "https://grupomv.mx/images/logos/4.png",
          color: "bg-white",
          route: "/139-suprema",
        },

        {
          image:
            "https://th.bing.com/th/id/OIP.JE5lQeQFTIDRx7xOAWzt6QAAAA?rs=1&pid=ImgDetMain",
          color: "bg-white",
          route: "/103-redbull",
        },
        {
          image:
            "https://i0.wp.com/lfa.mx/2018/wp-content/uploads/2018/02/electrolit-logo.png?fit=600%2C600&ssl=1",
          color: "bg-white",
          route: "/101-ElectrolitView",
        },
        {
          image:
            "https://th.bing.com/th/id/OIP.t2Gbf1ArhYU5L2AKNUHZpQHaFI?rs=1&pid=ImgDetMain",
          color: "bg-black",
          route: "/101-JackDanielsView",
        },
        {
          image: "https://grupomv.mx/images/logos/10.png",
          color: "bg-deep-purple-darken-4",
          route: "/101-NewMix",
        },
        {
          image: "https://http2.mlstatic.com/D_Q_NP_640619-MLA28280782002_102018-F.jpg",
          color: "bg-white",
          route: "/101-CaribeCoolerView",
        },
        {
          image:
            "https://d1yjjnpx0p53s8.cloudfront.net/styles/logo-thumbnail/s3/0013/6452/brand.gif?itok=bBsc-K9p",
          color: "bg-white",
          route: "/101-BoonesView",
        },
        {
          image: "https://sitecoreaudioprod.umusicpub.com/sitecore_media/1B01EEBD-C4B8-4C75-8E79-C7F0131FC0DA.jpg",
        color: "bg-amber",

          route: "/101-vuala",
        },
        {
          image: "https://www.clamato.com/img/clamato-logo-large.png",
          color: "bg-red",
          route: "/101-ClamatoView",
        },

        {
          image:
            "https://www.nissinfoods.com/wp-content/uploads/2023/03/cup-noodles-nissin-1.png",
          color: "bg-white",
          route: "/141-nissin",
        },
      ],
      brands: [
        { id: 1, name: "Refrescos", logo: "https://grupomv.mx/images/logos/1.png" },
        {
          id: 2,
          name: "Aguafiel",
          logo:
            "https://th.bing.com/th/id/OIP.OVVHgJlT2TGdQ76Wbxcj8gHaHa?rs=1&pid=ImgDetMain",
        },
        {
          id: 3,
          name: "Dulces",
          logo: "https://proan.com/wp-content/uploads/2023/02/Group-129.png",
        },
        {
          id: 4,
          name: "Preparadas",
          logo: "https:///images/JD%20RTD%20MINERAL%206350%20ML.webp",
        },
        {
          id: 5,
          name: "Energizantes",
          logo: "https://mir-s3-cdn-cf.behance.net/project_modules/1400/74fd09177758701.64dc4a81f1ab3.png",
        },
        { id: 6, name: "Tostadas", logo: "" },
      ],
      products: [
        {
          brand: "Refrescos",
          category: "Refrescos",
          image:
            "https://m.media-amazon.com/images/I/61tArldLWVL._AC_UF350,350_QL80_.jpg",
          route: "/101List",
        },
        {
          brand: "Tostadas",
          category: "Tostadas",
          image:
            "https://mvexpress.mx/images/publicidad/suprema/tostadas_app.jpg",
          route: "/139-suprema",
        },
        {
          brand: "Energetizantes",
          category: "Energetizantes",
          image:
            "https://mir-s3-cdn-cf.behance.net/project_modules/1400/74fd09177758701.64dc4a81f1ab3.png",
          route: "/100-EnergetizantesView",
        },
        {
          brand: "Preparadas",
          category: "Tequila",
          image: "https://m.media-amazon.com/images/I/71ykFJMiUZL.jpg",
          route: "/101-NewMix",
        },
        {
          brand: "Clamato",
          category: "Bebidas",
          image: "https://m.media-amazon.com/images/I/815-WNfqyJL.jpg",
          route: "/101-ClamatoView",
        },

        {
          brand: "Bebidas",
          category: "Alcohólicas",
          image: "https://boones.s3.amazonaws.com/ponche_de_durazno_49102de991.png",
          route: "/bebidas-alcho",
        },

        {
          brand: "Aguafiel",
          category: "Aguafiel",
          image:
            "https://tse3.mm.bing.net/th/id/OIP.7_L2KwxH3ugsrPy4zkuu1wHaHa?rs=1&pid=ImgDetMain&o=7&rm=3",
          route: "/100-aguafiel",
        },
      ],
    };
  },
  computed: {
    filteredOfertados() {
      const query = this.searchQuery.toLowerCase().trim();
      if (!query) return this.ofertados;
      return this.ofertados.filter((product) =>
        [product.nombre, product.marca, product.category].some(
          (field) => field && field.toLowerCase().includes(query)
        )
      );
    },
  },
  methods: {
      async obtenerNuevaData() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        if (!user || !user.id) {
          console.error("Usuario no encontrado en localStorage");
          return;
        }

        const response = await axios.get(
          `https://mvexpress.mx/api/get-mvcoins/${user.id}`
        );

        this.userData = response.data;
        // Actualiza el usuario en localStorage
        //  alert("Datos del usuario actualizados"+ JSON.stringify(this.userData));
        // Actualiza el usuario en el estado del componente
        this.user = this.userData;
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    },

    async verificarPolitica() {
      await this.userStore.obtenerNuevaData();
      if (!this.userStore.user?.politica_privacidad_aceptada) {
        alert("Debes aceptar el aviso de privacidad antes de continuar.");
        window.location.replace("/aviso-privacidad");
      }
    },
    showNotification(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    startPointer(e, route) {
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.tappingRoute = route;
    },

    endPointer(e) {
      const dx = Math.abs(e.clientX - this.startX);
      const dy = Math.abs(e.clientY - this.startY);
      const tolerance = 5; // permite un pequeño movimiento sin cancelar tap
      if (dx < tolerance && dy < tolerance && this.tappingRoute) {
        this.navigateTo(this.tappingRoute);
      }
      this.tappingRoute = null;
    },

    handleScroll() {
      const container = this.$refs.ofertadosContainer;
      if (
        container &&
        container.scrollTop + container.clientHeight >= container.scrollHeight - 10
      ) {
        this.fetchOfertados(true);
      }
    },
    showSweetAlert() {
      Swal.fire({
        title: "Hola",
        text: "Da click para agregar promoción al carrito",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Agregar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("Promoción agregada al carrito");
        }
      });
    },
    openCart() {
      this.cartDialog = true;
      this.suggestedProducts();
    },
    suggestedProducts() {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found. Please login first.");
        return;
      }
      axios
        .get("https://mvexpress.mx/api/suggested-products", {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.suggestedItems = res.data;
          } else {
            console.error("No se encontraron productos sugeridos.");
          }
        })
        .catch((err) => {
          console.error("Error fetching suggested products:", err);
        });
    },

    clearOfertadosCache() {
      localStorage.removeItem("ofertadosCache");
      localStorage.removeItem("ofertadosCacheTime");
      this.ofertados = [];
      this.offset = 0;
    },

    goToPromo() {
      this.$router.push("/promo");
    },
    async fetchOfertados(more = false) {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found. Please login first.");
        return;
      }
      if (!more) {
        const cache = localStorage.getItem("ofertadosCache");
        const cacheTime = parseInt(localStorage.getItem("ofertadosCacheTime"), 10);
        const now = Date.now();

        if (cache && cacheTime && now - cacheTime < 600000) {
          this.ofertados = JSON.parse(cache);
          this.offset = this.ofertados.length;
          return;
        }

        this.offset = 0;
        this.ofertados = [];
      }

      try {
        const response = await axios.get("https://mvexpress.mx/api/100-ofertar", {
          headers: { Authorization: `Bearer ${token}` },
          params: { offset: this.offset, limit: this.limit },
        });

        if (more) {
          this.ofertados = this.ofertados.concat(response.data);
        } else {
          this.ofertados = response.data;
          localStorage.setItem("ofertadosCache", JSON.stringify(response.data));
          localStorage.setItem("ofertadosCacheTime", Date.now());
        }

        this.offset += this.limit;
      } catch (error) {
        console.error("Error al obtener promociones:", error);
      }
    },
    navigateTo(route) {
      this.$router.push(route);
    },
  },

  async mounted() {
    this.clearOfertadosCache();
    this.fetchOfertados();

     this.verificarPolitica();

    const saveCart = localStorage.getItem("cart");
    if (saveCart) {
      this.cart = JSON.parse(saveCart);
    }

    this.$refs.ofertadosContainer?.addEventListener("scroll", this.handleScroll);

    // 👋 Mensaje de bienvenida
    this.showNotification("Bienvenido a la aplicación", "success");

    // 🧠 Cargar usuario
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return;

    this.user = JSON.parse(storedUser);
    console.log("Usuario cargado:", this.user);

    // 🧭 Validar que tenga direcciones
    if (
      this.user &&
      Array.isArray(this.user.direcciones) &&
      this.user.direcciones.length > 0
    ) {
      const dir = this.user.direcciones[0];
      let diaPreventa = null;

      if (dir.CTEDIR_SECUENCIALU) diaPreventa = "Lunes";
      else if (dir.CTEDIR_SECUENCIAMA) diaPreventa = "Martes";
      else if (dir.CTEDIR_SECUENCIAMI) diaPreventa = "Miércoles";
      else if (dir.CTEDIR_SECUENCIAJU) diaPreventa = "Jueves";
      else if (dir.CTEDIR_SECUENCIAVI) diaPreventa = "Viernes";
      else if (dir.CTEDIR_SECUENCIASA) diaPreventa = "Sábados";
      else if (dir.CTEDIR_SECUENCIADO) diaPreventa = "Domingos";

      if (diaPreventa) {
        console.log("🗓️ Día de preventa:", diaPreventa);
        this.preventaSnackbar.message = `🗓️ Tu dia  de pedido son los dias ${diaPreventa}`;
        this.preventaSnackbar.show = true;
      }

      // 📅 Ver si HOY coincide
      const diasSemana = [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ];
      const hoy = diasSemana[new Date().getDay()]; // nombre del día actual en minúscula

      const dias = this.user.direcciones
        .map((d) => (d.dia?.toLowerCase() === hoy ? "HOY" : d.dia))
        .join(", ");

      this.showNotification(`Tus días de entrega son ${dias}`, "info");
    } else {
      console.log("⚠️ Este usuario no tiene direcciones registradas.");
    }
  },

  beforeUnmount() {
    this.$refs.ofertadosContainer?.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.floating-cart-btn {
  position: fixed;
  bottom: 200px;
  right: 20px;
  width: 80px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

/* Burbuja de contador */
.cart-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: red;
  color: white;
  font-size: 12px;
  font-weight: bold;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
}
.snackbar-top {
  top: 30px !important;
  /* Ajusta la distancia del top */
  bottom: auto !important;
  z-index: 2000 !important;
}

.main-content {
  height: 100vh;
  /* Ocupa toda la pantalla */
  padding-bottom: 80px;
  /* Deja espacio para la bottom-navigation */
}

.marcas {
  display: flex;
  /* asegura que flex funcione */
  justify-content: center;
  /* centra elementos */
  overflow-x: auto;
  /* scroll horizontal */
  padding: 0 16px;
  /* margen interno */
  gap: 20px;
  /* espacio entre items */
  scroll-behavior: smooth;
  /* scroll suave */
}

.marcas::-webkit-scrollbar {
  display: none;
}

/* Cada item no se reduce */
.marcas .v-col {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  /* centra contenido dentro de la columna */
  padding: 0;
}
.fixed-cart-btn {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;

  /* SUBE el botón justo arriba de la bottom nav */
  bottom: calc(env(safe-area-inset-bottom) + 70px);

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;

  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  font-size: 16px;
  background-color: #fff;
}

.fixed-bottom-nav {
  position: fixed;
  left: 0;
  right: 0;
  bottom: env(safe-area-inset-bottom); /* respeta la zona segura del teléfono */
  z-index: 9999;
}

/* Para Samsung donde env(safe-area) no se reporta correctamente */
@supports (bottom: env(safe-area-inset-bottom)) {
  .fixed-cart-btn {
    bottom: calc(max(env(safe-area-inset-bottom), 20px) + 70px);
  }
}

</style>
